import React, { useState, useEffect, useRef } from 'react';

import './carousel.scss';

const Carousel = ({ children }) => {
  const [showLeftArrow, setshowLeftArrow] = useState(false);
  const [showRightArrow, setshowRightArrow] = useState(true);

  const ref = useRef(null);

  useEffect(() => {
    window.addEventListener('resize', onResize);

    return () => window.removeEventListener('resize', onResize);
  }, []);

  function onResize() {
    window.setTimeout(updateCarouselArrowStates, 200);
  }

  function updateCarouselArrowStates() {
    let showLeftArrow = true;
    let showRightArrow = true;

    const { scrollWidth } = ref.current;
    const { clientWidth } = ref.current;
    const { scrollLeft } = ref.current;
    const carouselWidth = scrollWidth - clientWidth;

    if (scrollLeft === 0) {
      showLeftArrow = false;
    }
    if (
      (Math.ceil(scrollLeft) === carouselWidth || scrollWidth === clientWidth) &&
      carouselWidth > 0
    ) {
      showRightArrow = false;
    }

    setshowLeftArrow(showLeftArrow);
    setshowRightArrow(showRightArrow);
  }

  function scrollCarousel(direction) {
    const distance = 500;
    const multiple = direction === 'left' ? -1 : 1;
    ref.current.scrollBy(distance * multiple, 0);
  }

  const rightArrow = showRightArrow ? (
    <div className="arrow-container right" onClick={() => scrollCarousel('right')}>
      <div className="arrow-right"></div>
    </div>
  ) : null;

  const leftArrow = showLeftArrow ? (
    <div className="arrow-container left" onClick={() => scrollCarousel('left')}>
      <div className="arrow-left"></div>
    </div>
  ) : null;

  return (
    <div className="carousel">
      {leftArrow}
      <div className="carousel-items" ref={ref} onScroll={updateCarouselArrowStates}>
        {children}
      </div>
      {rightArrow}
    </div>
  );
};

export default Carousel;
